export default __webpack_public_path__ + "static/media/consulat-us.0dc737ea.jpg";